import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { usePxToVw } from "../../hooks/usePxToVw";
import LoadingOverlay from "./LoadingOverlay";
import WayfinderDialog from "./WayfinderDialog";
import MappedInMap from "./MappedInMap";
import VideoPlayerMenu from "../backend/buttonApp/buttonAppFrontendView/VideoPlayerMenu";
import BostonMap from "./BostonMap";
import { useMappedInSettings } from "../../hooks/useMappedInSettings";
import WeatherWidget from "../WeatherWidget";


const AvatarScreen = ({
  userId,
  brandColor,
  brandFont,
  onBack,
  locationData,
  handleSubLocationSelect,
  removeWhiteFlashOnVideo = false,
  timeoutPopupSettings,
  replayPopupSettings, // Add replay popup settings prop
  captionSettings, // Add caption settings prop
  backButtonSettings, // Add global back button settings
  qrCodeSettings, // Add global QR code settings
  mapPositionSettings, // Add global map position settings
  language = "en", // Add language prop with default (DEPRECATED - use selectedLanguage)
  isCaptionOn, // Add caption state from parent
  setIsCaptionOn, // Add caption setter from parent
  resetSession, // Add resetSession function from parent
  cameFromSearch = false, // Add prop to know if user came from search screen
  logoBeforeMap,

  // Language props for video selection
  selectedLanguage = "en",
  videoList = [], // Add video list prop to find language-specific videos
  autoCloseReplayPopup = false, // Add prop to auto-close replay popup (for standalone mode)
  
  // External state control for replay modal (optional - for standalone mode)
  replayModal = null, // External replay modal state
  setReplayModal = null, // External replay modal setter
  weatherSettings = { enabled: false }, // Weather settings from parent

  qrCodeConfig,
}) => {
  console.log("backButtonSettings data", backButtonSettings);


  // Use selectedLanguage instead of language prop
  const currentLanguage = selectedLanguage || language || "en";

  console.log("🌐 AvatarScreen - Current Language:", currentLanguage);
  console.log("🌐 AvatarScreen - selectedLanguage prop:", selectedLanguage);
  console.log("🌐 AvatarScreen - language prop (deprecated):", language);

  console.log("Qr cod esettingsss", qrCodeSettings);

  console.log("locationData", locationData)

  const mapContainerRef = useRef(null);

  const { settings: mapSettings } =
    useMappedInSettings(userId);


  console.log("mappedInConfig", mapSettings);

  const [isHoveredButton, setIsHoveredButton] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [videoData, setVideoData] = useState(null);
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(null);
  const [videoKey, setVideoKey] = useState(""); // Add video key for VideoPlayerMenu

  const timeoutRef = useRef(null);
  const countdownRef = useRef(null);
  const videoRef = useRef(null);

  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
  });

  const [timeoutOpen, setTimeoutOpen] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(timeoutPopupSettings?.avatarScreen?.countdownDuration || 5);
  const [videoStarted, setVideoStarted] = useState(false);
  const [mapVisible, setMapVisible] = useState(true);
  const [showFallbackMap, setShowFallbackMap] = useState(false);

  // Remove local isCaptionOn state - now using parent state via props
  const [isMapReady, setIsMapReady] = useState(false);
  const [videoCompleted, setVideoCompleted] = useState(false);
  const [navigationCompleted, setNavigationCompleted] = useState(false);
  const [experienceCompleted, setExperienceCompleted] = useState(false);
  const [videoPlayedOnce, setVideoPlayedOnce] = useState(false);
  
  // Use external state if provided (for standalone mode), otherwise use internal state
  const [internalReplayDialogOpen, setInternalReplayDialogOpen] = useState(false);
  const replayDialogOpen = replayModal !== null ? replayModal : internalReplayDialogOpen;
  const setReplayDialogOpen = setReplayModal !== null ? setReplayModal : setInternalReplayDialogOpen;
  
  const [replayCountdown, setReplayCountdown] = useState(5);
  const [isWaitingForTimeout, setIsWaitingForTimeout] = useState(false); // New state for close window functionality

  const replayCountdownRef = useRef(null);
  const mapVideoRef = useRef(null);
  const [mapKey, setMapKey] = useState(0);

  // State for dynamic QR code URL with language parameter
  const [qrCodeUrlWithLanguage, setQrCodeUrlWithLanguage] = useState(null);

  // Helper function to get text for current language
  const getTextForLanguage = (textObj, fallback = '') => {
    if (!textObj) return fallback;
    
    // If it's already a string, return it
    if (typeof textObj === 'string') return textObj;
    
    // If it's an object with language keys
    if (typeof textObj === 'object' && textObj !== null) {
      // Try to get text for selected language
      if (textObj[currentLanguage]) return textObj[currentLanguage];
      
      // Fallback to English
      if (textObj['en']) return textObj['en'];
      
      // Fallback to first available language
      const firstKey = Object.keys(textObj)[0];
      if (firstKey && textObj[firstKey]) return textObj[firstKey];
    }
    
    return fallback;
  };

  // Generate QR code URL with language parameter for tracking
  useEffect(() => {
    if (locationData && currentLanguage) {
      // Priority 1: Check if direct map link QR is enabled and available
      if (qrCodeConfig?.enableDirectMapLinkQr && locationData?.directMapLinkQrCode?.[currentLanguage]?.fileUrl) {
        console.log('✅ Using direct map link QR code');
        setQrCodeUrlWithLanguage(locationData.directMapLinkQrCode[currentLanguage].fileUrl);
        return;
      }

      // Priority 2: Use regular QR code (existing logic)
      if (locationData?.qrCode) {
        const qrCodeForLanguage = locationData.qrCode[currentLanguage] || locationData.qrCode['en'] || locationData.qrCode;

        console.log('🔵 QR Code language selection:', {
          currentLanguage,
          availableQRCodes: Object.keys(locationData.qrCode || {}),
          selectedQRCode: qrCodeForLanguage,
        });

        // Use the language-specific QR code if available
        if (qrCodeForLanguage?.qrUrl) {
          // The qrUrl already contains the language parameter from backend
          const destinationUrl = qrCodeForLanguage.qrUrl;

          // Generate QR code image with the language-specific URL
          const newQrCodeUrl = qrCodeForLanguage.fileUrl || `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(destinationUrl)}`;

          console.log('✅ Using language-specific QR code:', {
            language: currentLanguage,
            destinationUrl,
            qrCodeImageUrl: newQrCodeUrl,
          });

          setQrCodeUrlWithLanguage(newQrCodeUrl);
        } else if (qrCodeForLanguage?.fileUrl) {
          // Fallback to QR code file URL if available
          console.log('⚠️ Using fallback QR code fileUrl');
          setQrCodeUrlWithLanguage(qrCodeForLanguage.fileUrl);
        } else {
          console.log('❌ No QR code found for language:', currentLanguage);
          setQrCodeUrlWithLanguage(null);
        }
      } else {
        setQrCodeUrlWithLanguage(null);
      }
    } else {
      setQrCodeUrlWithLanguage(null);
    }
  }, [locationData?.qrCode, locationData?.directMapLinkQrCode, currentLanguage, qrCodeConfig?.enableDirectMapLinkQr]);

  const handleVideoPlayPage = () => {
    console.log("▶ Video started");
  };

  // Responsive design calculations
  const isSmallScreen = windowSize.width < 1200;
  const isMobileScreen = windowSize.width < 768;

  const { pxToVw } = usePxToVw();

  // Responsive map dimensions
  const getMapStyle = () => {
    // Priority: locationData.mapPosition > global mapPositionSettings > defaults
    const customMapPosition = mapPositionSettings;

    console.log("Map Position settings", locationData.mapPosition);

    console.log("Map position settings:", customMapPosition);

    // Default values - width/height in pixels, offsets in percentage
    const defaultPosition = {
      widthPx: 537,
      heightPx: 1080,
      top: 10,
      right: 3,
      left: null,
      bottom: null,
      boxShadow: {
        shadowAngle: 45,
        shadowSize: 5,
        shadowDistance: 2,
        shadowAlpha: 0.3,
        shadowColor: "#000000",
      },
      borderColor: "#000000",
      borderWidth: "1",
      borderRadius: "8",
    };

    // Use custom settings if available, otherwise use defaults
    const mapConfig = customMapPosition || defaultPosition;

    // Helper function to calculate box shadow
    const getBoxShadow = (boxShadow) => {
      const {
        shadowAngle = 45,
        shadowSize = 5,
        shadowDistance = 2,
        shadowAlpha = 0.3,
        shadowColor = "#000000",
      } = boxShadow || {};

      const degToRad = (deg) => deg * (Math.PI / 180);
      const rad = degToRad(shadowAngle);
      const x = Math.cos(rad) * shadowDistance;
      const y = Math.sin(rad) * shadowDistance;

      const hexToRgba = (hex, alpha = 1) => {
        let c = hex.replace("#", "");
        if (c.length === 3) {
          c = c
            .split("")
            .map((x) => x + x)
            .join("");
        }
        const r = parseInt(c.substring(0, 2), 16);
        const g = parseInt(c.substring(2, 4), 16);
        const b = parseInt(c.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      };

      const rgbaColor = hexToRgba(shadowColor, shadowAlpha);
      const blur = shadowSize * 2;
      const spread = shadowSize * 0.5;
      return `${x}px ${y}px ${blur}px ${spread}px ${rgbaColor}`;
    };

    // Build the style object using pxToVw for width/height
    const style = {
      position: "fixed",
      width: pxToVw(
        typeof mapConfig.widthPx === "number"
          ? mapConfig.widthPx
          : defaultPosition.widthPx,
      ),
      height: pxToVw(
        typeof mapConfig.heightPx === "number"
          ? mapConfig.heightPx
          : defaultPosition.heightPx,
      ),
      // Apply border styling
      border: `${mapConfig.borderWidth || defaultPosition.borderWidth}px solid ${mapConfig.borderColor || defaultPosition.borderColor}`,
      borderRadius: pxToVw(
        mapConfig.borderRadius || defaultPosition.borderRadius,
      ),
      // Apply box shadow
      boxShadow: getBoxShadow(mapConfig.boxShadow || defaultPosition.boxShadow),
    };

    if (typeof mapConfig.bottom === "number") {
      style.bottom = `${mapConfig.bottom}%`;
      style.top = "unset";
    } else if (typeof mapConfig.top === "number") {
      style.top = `${mapConfig.top}%`;
      style.bottom = "unset";
    } else {
      // If both are null, use default top
      style.top = `unset`;
      style.bottom = "unset";
    }

    // Handle horizontal positioning (left takes priority if set)
    if (typeof mapConfig.left === "number") {
      style.left = `${mapConfig.left}%`;
      style.right = "unset";
    } else if (typeof mapConfig.right === "number") {
      style.right = `${mapConfig.right}%`;
      style.left = "unset";
    } else {
      // If both are null, use default right
      style.right = `unset`;
      style.left = "unset";
    }

    console.log("Computed map style:", style);

    return style;
  };

  // Dialog settings for the timeout dialog
  const dialogSettings = {
    backgroundColor: "#FFFFFF",
    borderColor: brandColor || "#127E10",
    borderWidth: 3,
    borderRadius: 20,
    popupWidth: 500,
    popupPadding: 40,
    fontFamily: brandFont || "Arial",

    // Text settings
    text: {
      content: "Are You Still There?",
      textAlign: "center",
      fontSize: 32,
      color: "#333333",
      fontWeight: 600,
      padding: 20,
    },

    // Subtitle settings
    subtitle: {
      content: "Returning to main menu in...",
      textAlign: "center",
      fontSize: 18,
      color: "#666666",
      fontWeight: 400,
      padding: 10,
    },

    // Countdown settings
    countdown: {
      fontSize: 48,
      color: brandColor || "#127E10",
      fontWeight: 700,
      padding: 8,
    },

    // Button settings
    button: {
      text: "Yes, I'm Here",
      backgroundColor: brandColor || "#127E10",
      textColor: "#FFFFFF",
      fontSize: 24,
      paddingTopBottom: 15,
      paddingLeftRight: 40,
      borderRadius: 8,
      borderWidth: 0,
      borderColor: "transparent",
      alignment: "center",
      containerPadding: 30,
      width: 200,
      minWidth: 120,
      hoverBackgroundColor: brandColor ? `${brandColor}CC` : "#127E10CC",
      hoverTextColor: "#FFFFFF",
      fontWeight: 600,
      shadow: {
        shadowDistance: 4,
        shadowSize: 12,
        shadowColor: "#00000033",
      },
      letterSpacing: 0,
      textTransform: "none",
      opacity: 1,
    },
  };

  // Fetch video data from LocationVideoStatus
  useEffect(() => {
    const fetchVideoData = async () => {
      if (!locationData?._id || !userId) {
        console.log("Missing locationData._id or userId");
        setVideoLoading(false);
        return;
      }

      try {
        setVideoLoading(true);
        setVideoError(null);

        console.log("Fetching video data for location:", locationData._id);
        console.log(
          "enableCustomAvatarVideo:",
          locationData?.avatarVideo?.enabled,
        );
        console.log(
          "avatarVideosMultiLang:",
          locationData.avatarVideosMultiLang,
        );
        console.log("🌐 Using language for video fetch:", currentLanguage);

        // Priority 1: Check for custom avatar video (ONLY if enabled)
        if (
          locationData?.avatarVideo?.enabled &&
          locationData.avatarVideo?.fileUrl
        ) {
          console.log("🎬 AvatarScreen: Using custom avatar video (enabled)");
          const customVideoData = {
            videoId: `custom_avatar_${locationData._id}`,
            status: "completed",
            awsVideoUrl: locationData.avatarVideo.fileUrl,
            videoUrl: locationData.avatarVideo.fileUrl,
            captionFile: locationData?.avatarVideo?.captionFile,
            createdAt: new Date().toISOString(),
          };

          setVideoData(customVideoData);
          const videoKey = `location_video_${locationData._id}_custom`;
          setVideoKey(videoKey);
          setVideoLoading(false);
          return;
        }

        // Priority 2: Check for generated multilanguage video from avatarVideosMultiLang
        if (
          locationData.avatarVideosMultiLang &&
          locationData.avatarVideosMultiLang[currentLanguage]
        ) {
          const langVideo = locationData.avatarVideosMultiLang[currentLanguage];
          console.log(
            `🎬 AvatarScreen: Checking avatarVideosMultiLang[${currentLanguage}]:`,
            langVideo,
          );

          if (
            langVideo.status === "completed" &&
            (langVideo.awsVideoUrl || langVideo.fileUrl)
          ) {
            console.log(
              `🎬 AvatarScreen: Using generated multilanguage video from avatarVideosMultiLang[${currentLanguage}]`,
            );
            const generatedVideoData = {
              videoId:
                langVideo.videoId ||
                `generated_${locationData._id}_${currentLanguage}`,
              status: "completed",
              awsVideoUrl: langVideo.awsVideoUrl || langVideo.fileUrl,
              videoUrl: langVideo.fileUrl || langVideo.awsVideoUrl,
              captionFile: langVideo?.captionFile || '',
              createdAt: new Date().toISOString(),
            };

            setVideoData(generatedVideoData);
            const videoKey = `location_video_${locationData._id}_${currentLanguage}`;
            setVideoKey(videoKey);
            setVideoLoading(false);
            return;
          }
        }

        // Priority 3: Fetch from API as fallback
        console.log("🎬 AvatarScreen: Fetching from API as fallback");
        const response = await fetch(
          `/api/wayfinder/locations/${locationData._id}/video-status?language=${currentLanguage}`,
        );
        const data = await response.json();

        console.log("video status from API", data);

        if (data.success && data.data && data.data.length > 0) {
          console.log(
            "🎬 AvatarScreen: Raw video data received from API:",
            data.data,
          );

          // Find the most recent completed video
          const completedVideos = data.data.filter((video) => {
            const hasValidStatus = video.status === "completed";
            const hasVideoUrl = !!(video.awsVideoUrl || video.videoUrl);

            console.log(`🎬 AvatarScreen: Video ${video.videoId}:`, {
              status: video.status,
              hasAwsUrl: !!video.awsVideoUrl,
              hasVideoUrl: !!video.videoUrl,
              awsVideoUrl: video.awsVideoUrl,
              videoUrl: video.videoUrl,
              isValid: hasValidStatus && hasVideoUrl,
            });

            return hasValidStatus && hasVideoUrl;
          });

          console.log(
            "🎬 AvatarScreen: Completed videos found from API:",
            completedVideos.length,
          );

          if (completedVideos.length > 0) {
            // Sort by creation date and get the most recent
            const latestVideo = completedVideos.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            )[0];

            console.log("🎬 AvatarScreen: Using video from API");
            setVideoData(latestVideo);

            // Set video key for VideoPlayerMenu to match the format used in videoDB
            const videoKey = `location_video_${locationData._id}_${currentLanguage}`;
            console.log(
              "🎬 AvatarScreen: Setting videoKey to match videoDB format:",
              videoKey,
            );
            setVideoKey(videoKey);

            const actualVideoUrl =
              latestVideo.awsVideoUrl || latestVideo.videoUrl;
            console.log("🎬 AvatarScreen: Video URL:", actualVideoUrl);
            setVideoLoading(false);
            return;
          }
        }

        // Priority 4: Check for map video as final fallback
        if (locationData.enableMapVideo && locationData.mapVideo?.fileUrl) {
          console.log("🎬 AvatarScreen: Using map video as final fallback");
          const mapVideoData = {
            videoId: `map_video_${locationData._id}`,
            status: "completed",
            awsVideoUrl: locationData.mapVideo.fileUrl,
            videoUrl: locationData.mapVideo.fileUrl,
            createdAt: new Date().toISOString(),
          };

          setVideoData(mapVideoData);
          const videoKey = `location_video_${locationData._id}_map`;
          setVideoKey(videoKey);
          setVideoLoading(false);
          return;
        }

        // No video available
        console.log("No video available from any source");
        setVideoError("No video available for this location");
      } catch (error) {
        console.error("Error fetching video data:", error);
        setVideoError("Failed to load video data");
      } finally {
        setVideoLoading(false);
      }
    };

    fetchVideoData();
  }, [
    locationData?._id,
    userId,
    currentLanguage,
    locationData?.avatarVideo?.enabled,
    locationData?.avatarVideo?.fileUrl,
    locationData?.avatarVideosMultiLang,
    locationData?.enableMapVideo,
    locationData?.mapVideo?.fileUrl,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  console.log("Lcoation Dataaaa", locationData);

  // Show map after video starts (only if runOnlyAvatarVideo is false)
  // QR code visibility is independent and handled separately
  // useEffect(() => {
  //   if (videoStarted) {
  //     // Use mapDelayTime from locationData, default to 2 seconds
  //     const delayTime = (locationData?.mapDelayTime || 2) * 1000;

  //     const timer = setTimeout(() => {
  //       // Only show map if runOnlyAvatarVideo is false
  //       if (!locationData?.runOnlyAvatarVideo) {
  //         setMapVisible(true);
  //       }

  //       // Check if MappedIn SDK failed to load after some time
  //       const fallbackTimer = setTimeout(() => {
  //         if (typeof window !== "undefined" && window.mappedInSDKError) {
  //           setShowFallbackMap(true);
  //         }
  //       }, 5000); // Show fallback after 5 seconds if SDK still not loaded

  //       return () => clearTimeout(fallbackTimer);
  //     }, delayTime);

  //     return () => clearTimeout(timer);
  //   }
  // }, [
  //   videoStarted,
  //   locationData?.mapDelayTime,
  //   locationData?.runOnlyAvatarVideo,
  // ]);

  // Handle video playback
  const handleVideoPlay = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = false;
      setVideoStarted(true);
    }
  };

  const handleVideoEnd = () => {
    console.log("Location video ended");
    setVideoCompleted(true);
    setVideoPlayedOnce(true);

    // If autoCloseReplayPopup is true (standalone mode), pause video and don't show the popup
    if (autoCloseReplayPopup) {
      console.log("Auto-close enabled - pausing video and not showing replay popup in standalone mode");
      setReplayDialogOpen(true);
      if (videoRef.current) {
        videoRef.current.pause();
      }
      return;
    }

    // Show new replay popup immediately after video ends (only if not in standalone mode)
    setTimeout(() => {
      console.log("Video completed - showing new replay popup");
      setReplayDialogOpen(true);
    }, 2000)

    // No countdown for the new popup - it stays open until user chooses
  };

  // Handle navigation completion from MappedInMap
  const handleNavigationComplete = () => {
    console.log("Navigation completed");
    setNavigationCompleted(true);
  };

  const handleBack = () => {
    clearAllTimers();
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    if (onBack) {
      onBack();
    }
  };

  // Clear all timers
  const clearAllTimers = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
    if (replayCountdownRef.current) {
      clearInterval(replayCountdownRef.current);
      replayCountdownRef.current = null;
    }
  };

  // Handle user clicking "Replay Directions"
  // Handle user clicking "Replay Directions"
  const handleReplayDirections = () => {
    console.log("User wants to replay directions - restarting video and map");
    setReplayDialogOpen(false);
    setIsWaitingForTimeout(false);
    clearAllTimers();

    // Reset all states to restart the experience
    setVideoCompleted(false);
    setNavigationCompleted(false);
    setVideoStarted(false);
    setVideoPlayedOnce(false);
    setIsMapReady(false);

    // First hide the map, then show it again to trigger the isVisible effect in both map components
    setMapVisible(false);

    // Force remount MappedInMap component by changing key
    setMapKey((prev) => prev + 1);

    // Small delay to ensure map is hidden before showing again
    setTimeout(() => {
      setMapVisible(true);
    }, 100);

    // Restart the video from the beginning
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch((error) => {
        console.error("Error restarting video:", error);
      });
    }

    console.log("Experience restarted from beginning - map will reinitialize");
  };

  // Handle user clicking "Back to Search"
  const handleBackToSearch = () => {
    console.log("User wants to go back to search");
    setReplayDialogOpen(false);
    setIsWaitingForTimeout(false);
    clearAllTimers();
    if (onBack) {
      onBack(); // This should navigate back to search screen
    }
  };

  // Handle user clicking "Close this Window"
  const handleCloseWindow = () => {
    console.log("User wants to close window - will wait for timeout");
    setReplayDialogOpen(false);
    setIsWaitingForTimeout(true);

    // Pause video and map on last frame
    if (videoRef.current) {
      videoRef.current.pause();
    }

    // Clear any existing timers first
    clearAllTimers();

    // Start 30-second timeout before showing popup again
    console.log("Starting 30-second timer for replay popup to reappear");
    // timeoutRef.current = 
    setTimeout(() => {
      console.log("30 seconds passed - showing replay popup again");
      setReplayDialogOpen(true);
      setIsWaitingForTimeout(false);
    }, 30000);
  };

  // Timeout handling - Start countdown
  const startCountdown = () => {
    // Get countdown duration from settings (default to 5 seconds)
    const countdownTime = timeoutPopupSettings?.avatarScreen?.countdownDuration || 5;
    setTimeoutCountdown(countdownTime);

    if (countdownRef.current) {
      clearInterval(countdownRef.current);
    }

    countdownRef.current = setInterval(() => {
      setTimeoutCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          handleTimeoutComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleTimeoutComplete = () => {
    console.log(
      "Timeout completed - calling resetSession",
    );
    setTimeoutOpen(false);
    clearAllTimers();
    if (resetSession) {
      resetSession();
    } else if (onBack) {
      // Fallback to onBack if resetSession is not provided
      onBack('mainMenu');
    }
  };

  const handleContinue = () => {
    console.log("User clicked continue - restarting video and map");
    setTimeoutOpen(false);
    clearAllTimers();

    // Reset all states to restart the experience
    setVideoCompleted(false);
    setNavigationCompleted(false);
    setVideoStarted(false);
    setMapVisible(false);
    setVideoPlayedOnce(false);

    // Restart the video from the beginning
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch((error) => {
        console.error("Error restarting video:", error);
      });
    }

    console.log("Video and map restarted - playing from beginning");
  };

  const resetTimeout = () => {
    // Only reset timeout if video has already played once and no popups are open and not waiting for close window timeout
    if (videoPlayedOnce && !timeoutOpen && !replayDialogOpen && !isWaitingForTimeout) {
      console.log("Resetting timeout - video already played once");
      clearAllTimers();

      // Start new 30-second timeout for normal inactivity
      timeoutRef.current = setTimeout(() => {
        console.log("30 seconds of inactivity - showing timeout popup");
        setTimeoutOpen(true);
        startCountdown();
      }, 30000);
    }
  };

  useEffect(() => {
    const events = ["mousedown", "keydown", "touchstart", "scroll"];
    const resetTimeoutOnInteraction = () => {
      // Only reset timeout if video has played and no popups are open and not waiting for close window timeout
      if (videoPlayedOnce && !timeoutOpen && !replayDialogOpen && !isWaitingForTimeout) {
        resetTimeout();
      }
    };

    events.forEach((event) => {
      window.addEventListener(event, resetTimeoutOnInteraction);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimeoutOnInteraction);
      });

      clearAllTimers();
    };
  }, [videoPlayedOnce, timeoutOpen, replayDialogOpen, isWaitingForTimeout]);

  const buttonStyle = (item) => {
    const settings = item.customSettings || locationData?.globalSettings;
    const isHovered = isHoveredButton === item._id;

    return {
      padding: `${pxToVw(settings?.padding || 15)}`,
      fontSize: `${pxToVw(settings?.fontSize || 20)}`,
      fontWeight: settings?.fontWeight || "600",
      borderRadius: `${settings?.cornerRadius || 8}px`,
      border: `${settings?.outlineThickness || 2}px solid ${settings?.outlineColor || brandColor || "#000000"}`,
      backgroundColor: isHovered
        ? settings?.highlight?.fillColor ||
        settings?.fillColor ||
        brandColor ||
        "#127E10"
        : settings?.fillColor || "#ffffff",
      color: isHovered
        ? settings?.highlight?.fontColor || settings?.fontColor || "#ffffff"
        : settings?.fontColor || brandColor || "#127E10",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      fontFamily: brandFont || settings?.font || "Arial",
      minHeight: `${pxToVw(settings?.height || 60)}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      width: "100%",
    };
  };

  const getCaptionFileUrl = (locationData, language) => {
    // ✅ Priority 1: avatarVideo
    if (locationData?.avatarVideo?.enabled) {
      if (locationData?.avatarVideo?.captionFile) {
        return locationData.avatarVideo.captionFile;
      } else {
        return "";
      }
    }

    // ✅ Priority 2: avatarVideosMultiLang (ONLY if avatarVideo is disabled)
    if (locationData?.avatarVideosMultiLang?.[language]?.enabled) {
      if (locationData?.avatarVideosMultiLang?.[language]?.captionFile) {
        return locationData.avatarVideosMultiLang[language].captionFile;
      } else {
        return "";
      }
    }
    return "";
  };

  // Get video URL (prefer AWS URL, fallback to regular URL)
  const getVideoUrl = () => {
    if (!videoData) {
      console.log("🎬 AvatarScreen: getVideoUrl() - No videoData available");
      return null;
    }

    // Prioritize AWS URL (permanent storage) over temporary videoUrl
    const videoUrl = videoData.awsVideoUrl || videoData.videoUrl || null;

    console.log("🎬 AvatarScreen: getVideoUrl() analysis:");
    console.log(
      "🎬 AvatarScreen: - videoData.awsVideoUrl:",
      videoData.awsVideoUrl,
    );
    console.log("🎬 AvatarScreen: - videoData.videoUrl:", videoData.videoUrl);
    console.log("🎬 AvatarScreen: - Final selected URL:", videoUrl);
    console.log("🎬 AvatarScreen: - URL is valid:", !!videoUrl);

    return videoUrl;
  };

  const handleScreenClick = (e) => {
    // Only handle clicks when timeout popup is open (not replay dialog)
    if (timeoutOpen && !replayDialogOpen) {
      console.log(
        "Screen clicked while timeout popup open - closing popup and restarting",
      );
      handleContinue();
    }
  };

  // Helper function to get box shadow
  const getBoxShadow = (shadow) => {
    if (!shadow) return "none";
    const {
      shadowAngle = 45,
      shadowSize = 5,
      shadowDistance = 2,
      shadowAlpha = 1,
      shadowColor = "#000000",
    } = shadow;

    const degToRad = (deg) => deg * (Math.PI / 180);
    const rad = degToRad(shadowAngle);
    const x = Math.cos(rad) * shadowDistance;
    const y = Math.sin(rad) * shadowDistance;

    const hexToRgba = (hex, alpha = 1) => {
      let c = hex.replace("#", "");
      if (c.length === 3) {
        c = c
          .split("")
          .map((x) => x + x)
          .join("");
      }
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const rgbaColor = hexToRgba(shadowColor, shadowAlpha);
    const blur = shadowSize * 2;
    const spread = shadowSize * 0.5;
    return `${x}px ${y}px ${blur}px ${spread}px ${rgbaColor}`;
  };

  // Render the avatar screen popup using WayfinderDialog
  const renderReplayPopup = () => {
    if (!replayDialogOpen) return null;

    // Extract text with proper language handling
    const headerText = getTextForLanguage(
      timeoutPopupSettings?.avatarScreen?.headerText,
      "What would you like to do next?"
    );
    
    const replayButtonText = getTextForLanguage(
      timeoutPopupSettings?.avatarScreen?.replayButton?.text,
      "Replay Directions"
    );
    
    const backToSearchButtonText = getTextForLanguage(
      timeoutPopupSettings?.avatarScreen?.backToSearchButton?.text,
      "Back to Search"
    );
    
    const closeWindowButtonText = getTextForLanguage(
      timeoutPopupSettings?.avatarScreen?.closeWindowButton?.text,
      "Close this Window"
    );

    // Create settings for WayfinderDialog with avatar screen content
    const avatarDialogSettings = {
      ...timeoutPopupSettings,
      text: {
        content: headerText,
        color: timeoutPopupSettings?.text?.color || "#000000",
        fontSize: timeoutPopupSettings?.text?.fontSize || 20,
        fontWeight: timeoutPopupSettings?.text?.fontWeight || 600,
      },
      button: {
        text: replayButtonText,
        textColor: timeoutPopupSettings?.avatarScreen?.replayButton?.textColor || "#ffffff",
        backgroundColor: timeoutPopupSettings?.avatarScreen?.replayButton?.backgroundColor || brandColor || "#000000",
        borderRadius: timeoutPopupSettings?.avatarScreen?.replayButton?.borderRadius || "8",
        padding: timeoutPopupSettings?.avatarScreen?.replayButton?.padding || "20",
        fontSize: timeoutPopupSettings?.avatarScreen?.replayButton?.fontSize || "16",
        shadow: timeoutPopupSettings?.avatarScreen?.replayButton?.shadow || {},
      },
    };

    // Create secondary button (Back to Search - only if came from search)
    const secondaryButton = cameFromSearch ? {
      text: backToSearchButtonText,
      onClick: handleBackToSearch,
      textColor: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.textColor || "#ffffff",
      backgroundColor: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.backgroundColor || "#666666",
      borderRadius: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.borderRadius || "8",
      padding: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.padding || "20",
      fontSize: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.fontSize || "16",
      shadow: timeoutPopupSettings?.avatarScreen?.backToSearchButton?.shadow || {},
    } : null;

    // Create tertiary button (Close Window)
    const tertiaryButton = {
      text: closeWindowButtonText,
      onClick: handleCloseWindow,
      textColor: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.textColor || "#ffffff",
      backgroundColor: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.backgroundColor || "#999999",
      borderRadius: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.borderRadius || "8",
      padding: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.padding || "20",
      fontSize: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.fontSize || "16",
      shadow: timeoutPopupSettings?.avatarScreen?.closeWindowButton?.shadow || {},
    };

    return (
      <WayfinderDialog
        open={replayDialogOpen}
        onClose={() => { }} // Don't allow closing by clicking outside
        settings={avatarDialogSettings}
        brandColor={brandColor}
        brandFont={brandFont}
        onClick={handleReplayDirections}
        secondaryButton={secondaryButton}
        tertiaryButton={tertiaryButton}
        avatarScreenMode={true}
        resetSession={resetSession}
        countdown={timeoutCountdown}     
         />
    );
  };

  return (
    <div
      className="avatar-screen-container"
      onClick={handleScreenClick}
      style={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        // backgroundColor: '#000000',
        // overflow: 'hidden',
      }}
    >
      {/* Full Screen Video Background */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
      >
        {videoLoading && (
          <div
            style={{
              position: "absolute",
              top: "20%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              fontSize: "24px",
              zIndex: 10,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            Loading video...
          </div>
        )}

        {videoError && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              fontSize: "18px",
              textAlign: "center",
              zIndex: 10,
              padding: "20px",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              borderRadius: "10px",
            }}
          >
            <div>{videoError}</div>
            <div style={{ fontSize: "14px", marginTop: "10px", opacity: 0.7 }}>
              Location: {locationData?.name[selectedLanguage] || locationData?.name['en'] || "This location"}
            </div>
          </div>
        )}

        {/* Use VideoPlayerMenu component for better video handling */}
        {!videoLoading && !videoError && videoData && getVideoUrl() && (
          <AnimatePresence mode="wait">
            {(() => {
              console.log(
                "🎬 AvatarScreen: About to render VideoPlayerMenu with:",
              );
              console.log("🎬 AvatarScreen: - videoKey:", getVideoUrl());
              console.log("🎬 AvatarScreen: - videoDbKey:", videoKey);

              return (
                <VideoPlayerMenu
                  videoRef={videoRef}
                  videoKey={getVideoUrl()}
                  // videoDbKey={videoKey}
                  handleVideoPlayPage={handleVideoPlay}
                  handleVideoEnd={handleVideoEnd}
                  removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
                  captionFileUrl={getCaptionFileUrl(locationData, language)}
                  captionSettings={captionSettings}
                  setIsCaptionOn={setIsCaptionOn}
                  isCaptionOn={isCaptionOn}
                  selectedLanguage={selectedLanguage}
                  currentVideoLanguage={currentLanguage}
                  videoList={videoList}
                  locationId={locationData?._id}
                  locationVideo={true}
                />
              );
            })()}
          </AnimatePresence>
        )}

        {/* Fallback background if no video */}
        {!videoLoading && (!videoData || !getVideoUrl()) && (
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#1a1a1a",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "24px",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "48px", marginBottom: "20px" }}>🎥</div>
              <div>No video available</div>
              <div
                style={{ fontSize: "16px", marginTop: "10px", opacity: 0.7 }}
              >
                {locationData?.name[selectedLanguage] || locationData?.name['en'] || "This location"}
              </div>
            </div>
          </div>
        )}
      </div>

      {locationData?.uploadedUrls?.upperLeft?.enabled &&
        locationData?.uploadedUrls?.upperLeft?.fileUrl && (
          <div
            className="corner-item top-left"
            style={{
              position: "fixed",
              justifyContent: "start",
              zIndex: 20,
              maxWidth: "25vw",
            }}
          >
            <img
              src={locationData.uploadedUrls.upperLeft.fileUrl}
              alt="Top Left Logo"
              style={{
                width: `${locationData.uploadedUrls.upperLeft.width}%`,
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
              }}
            />
          </div>
        )}

      {locationData?.uploadedUrls?.upperRight?.enabled &&
        locationData?.uploadedUrls?.upperRight?.fileUrl && (
          <div
            className="corner-item top-right"
            style={{
              position: "fixed",
              zIndex: 20,
              justifyContent: "end",
              maxWidth: "25vw",
            }}
          >
            <img
              src={locationData.uploadedUrls.upperRight.fileUrl}
              alt="Top Right Logo"
              style={{
                width: `${locationData.uploadedUrls.upperRight.width}%`,
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
              }}
            />
          </div>
        )}

      {locationData?.uploadedUrls?.bottomLeft?.enabled &&
        locationData?.uploadedUrls?.bottomLeft?.fileUrl && (
          <div
            className="corner-item bottom-left"
            style={{
              position: "fixed",
              zIndex: 20,
              justifyContent: "start",
              maxWidth: "25vw",
            }}
          >
            <img
              src={locationData.uploadedUrls.bottomLeft.fileUrl}
              alt="Bottom Left Logo"
              style={{
                width: `${locationData.uploadedUrls.bottomLeft.width}%`,
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
              }}
            />
          </div>
        )}

      {locationData?.uploadedUrls?.bottomRight?.enabled &&
        locationData?.uploadedUrls?.bottomRight?.fileUrl && (
          <div
            className="corner-item bottom-right"
            style={{
              position: "fixed",
              zIndex: 20,
              justifyContent: "end",
              maxWidth: "25vw",
            }}
          >
            <img
              src={locationData.uploadedUrls.bottomRight.fileUrl}
              alt="Bottom Right Logo"
              style={{
                width: `${locationData.uploadedUrls.bottomRight.width}%`,
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
              }}
            />
          </div>
        )}

      {/* Global Back Button from BrandingSettings */}
      {backButtonSettings?.enabled &&
        backButtonSettings.custom === false &&
        backButtonSettings.buttonImage?.fileUrl ? (
        <div
          className="corner-item back-button"
        >
          <img

            src={backButtonSettings.buttonImage.fileUrl}
            alt="Back Button"
            style={{
              width:
                backButtonSettings.buttonImage?.width > 0
                  ? `${backButtonSettings.buttonImage?.width}%`
                  : "auto",
              cursor: "pointer",
            }}


            onClick={handleBack}
          />
        </div>
      ) : (
        <div
          className="corner-item back-button"
          style={{
            position: "fixed",
            top: `${backButtonSettings.position?.top || 50}%`,
            left: `${backButtonSettings.position?.left || 0}%`,
            zIndex: 25,
            cursor: "pointer",
            transform: backButtonSettings.custom
              ? `rotate(${backButtonSettings.angle || 0}deg)`
              : "none",
          }}
          onClick={handleBack}
        >
          <button
            style={{
              color: backButtonSettings.textColor || "#ffffff",
              backgroundColor: backButtonSettings.backgroundColor || "#000000",
              opacity: backButtonSettings.opacity || 0.9,
              fontSize: pxToVw(`${backButtonSettings.fontSize || 16}`),
              fontWeight: backButtonSettings.fontWeight || 500,
              padding: `${pxToVw(`${backButtonSettings.paddingTopBottom || 20}`)} ${pxToVw(`${backButtonSettings.paddingLeftRight || 24}`)}`,
              borderRadius: `${backButtonSettings.borderRadius?.topLeft || 8}px ${backButtonSettings.borderRadius?.topRight || 8}px ${backButtonSettings.borderRadius?.bottomRight || 8}px ${backButtonSettings.borderRadius?.bottomLeft || 8}px`,
              border: `${backButtonSettings.borderWidth || 1}px solid ${backButtonSettings.borderColor || "#000000"}`,
              cursor: "pointer",
              letterSpacing: `${backButtonSettings.letterSpacing || 0}px`,
              whiteSpace: "nowrap",
              width: pxToVw(`${backButtonSettings.width || 125}`),
              height: pxToVw(`${backButtonSettings.height || 50}`),
              textAlign: "center",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            {backButtonSettings.text || "Back"}
          </button>
        </div>
      )}

      {/* Location-specific back button (commented out - using global back button instead) */}
      {/* {locationData?.uploadedUrls?.backButton?.enabled &&
        locationData?.uploadedUrls?.backButton?.fileUrl && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "2%",
              zIndex: 25,
              cursor: "pointer",
            }}
            onClick={handleBack}
          >
            <img
              src={locationData.uploadedUrls.backButton.fileUrl}
              alt="Back Button"
              style={{
                width: "auto",
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))",
                transition: "transform 0.2s ease",
              }}
              onMouseEnter={e => (e.target.style.transform = "scale(1.1)")}
              onMouseLeave={e => (e.target.style.transform = "scale(1)")}
            />
          </div>
        )} */}

      {/* Only render map if runOnlyAvatarVideo is false */}
      {!locationData?.runOnlyAvatarVideo && (
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{
            opacity: mapVisible ? 1 : 0,
            x: mapVisible ? 0 : 100,
          }}
          transition={{ duration: 0.1, ease: "easeOut", delay: 0.1 }}
          style={{
            ...getMapStyle(),
            backgroundColor: "rgba(255, 255, 255, 0.98)",
            overflow: "hidden",
            zIndex: 15,
            backdropFilter: "blur(15px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {locationData?.enableMapVideo && locationData?.mapVideo?.fileUrl ? (
            mapVisible && (
              <VideoPlayerMenu
                videoRef={mapVideoRef}
                videoKey={locationData.mapVideo.fileUrl}
                videoDbKey={`location_map_video_${locationData._id}`}
                handleVideoPlayPage={() => {
                  console.log("Map video playing");
                  // Auto-play the map video when it becomes visible
                  if (mapVideoRef.current) {
                    mapVideoRef.current.play().catch((error) => {
                      console.error("Error playing map video:", error);
                    });
                  }
                }}
                handleVideoEnd={() => console.log("Map video ended")}
                removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
                captionFileUrl={locationData?.mapVideo?.captionFile || ""}
                captionSettings={captionSettings}
                setIsCaptionOn={setIsCaptionOn}
                isCaptionOn={isCaptionOn}
                selectedLanguage={selectedLanguage}
                currentVideoLanguage={currentLanguage}
                videoList={videoList}
                locationId={locationData?._id}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            )
          ) : (
            <div
              id="mappedin-map-div"
              style={{
                flex: 1,
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundColor: "rgba(248, 249, 250, 0.95)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ visibility: 'hidden', width: '100px', height: '100px', position: 'absolute', zIndex: -1 }} id="mappedin-map"></div>

              {mapSettings?.usePointrMap ? (
                <>

                  <BostonMap
                    isVisible={mapVisible}
                    START_POI_ID={mapSettings?.startLocation || ""}
                    DESTINATION_POI_ID={locationData?.locationPosId || ""}
                    key={mapKey}
                    logoBeforeMap={logoBeforeMap}
                  />
                </>
              ) : (
                <MappedInMap
                  spaceName={locationData?.spaceName}
                  externalId={locationData?.externalId}
                  key={mapKey}
                  floorLevel={locationData?.floorLevel}
                  videoData={videoData}
                  videoDuration={
                    locationData?.avatarVideo?.enabled
                      ? (locationData?.avatarVideo?.videoDuration || 0) * 1000
                      : locationData?.avatarVideosMultiLang?.[currentLanguage]
                        ?.videoDuration || 0
                  }
                  locationName={locationData.name[selectedLanguage]}
                  brandColor={brandColor}
                  mapDelayTime={locationData?.mapDelayTime || 2}
                  userId={userId}
                  isVisible={mapVisible}
                  onMapReady={() => {
                    console.log("✅ Map ready callback received in AvatarScreen");
                    setIsMapReady(true);
                  }}
                  onNavigationComplete={handleNavigationComplete}
                  onError={() => console.log("Error loading map")}
                  totalSteps={locationData?.totalSteps}

                  mapVisible={mapVisible}
                  stepDetails={locationData?.stepDetails || []}
                  staticMapDuration={locationData?.staticMapDuration}
                  logoBeforeMap={logoBeforeMap} 
                  currentLanguage={currentLanguage}
                />
               
              )}
            </div>
          )}
        </motion.div>
      )}

      {/* QR Code - Always show when available, independent of map visibility */}
      {locationData?.enableQrCode && qrCodeUrlWithLanguage && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{
            opacity: videoStarted ? 1 : 0,
            scale: videoStarted ? 1 : 0.8,
          }}
          transition={{ delay: 0.5, duration: 0.5 }}
          onAnimationComplete={() => {
            // Log QR code display with language for tracking
            if (videoStarted) {
              const qrType = qrCodeConfig?.enableDirectMapLinkQr && locationData?.directMapLinkQrCode?.[currentLanguage]?.fileUrl 
                ? 'Direct Map Link QR' 
                : 'Regular QR';
              console.log(`${qrType} displayed for location: ${locationData?.name[selectedLanguage] || locationData?.name['en'] || "This location"}, Language: ${language}`);
            }
          }}
          style={{
            position: "fixed",

            ...(() => {
              const qrConfig = qrCodeSettings || {
                widthPx: 403,
                heightPx: 326,
                top: null,
                bottom: 8,
                left: null,
                right: 3,
              };

              const style = {
                width: pxToVw(qrCodeSettings?.widthPx || 403),
                height: pxToVw(qrCodeSettings?.heightPx || 326),
              };

              // Apply position offsets
              if (typeof qrConfig.bottom === "number") {
                style.bottom = `${qrConfig.bottom}%`;
              } else if (typeof qrConfig.top === "number") {
                style.top = `${qrConfig.top}%`;
              } else {
                style.bottom = "8%"; // Default
              }

              if (typeof qrConfig.right === "number") {
                style.right = `${qrConfig.right}%`;
              } else if (typeof qrConfig.left === "number") {
                style.left = `${qrConfig.left}%`;
              } else {
                style.right = "3%"; // Default
              }

              return style;
            })(),
            // Only apply frame styling if showFrame is true
            ...(qrCodeSettings?.showFrame !== false ? {
              backgroundColor: qrCodeSettings?.backgroundTransparent 
                ? 'transparent' 
                : (qrCodeSettings?.backgroundColor || brandColor || "#ffffff"),
              padding: "10px",
              borderRadius: pxToVw(qrCodeSettings?.borderRadius || 20),
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
              border: `${pxToVw(qrCodeSettings?.borderWidth || 1)} solid ${qrCodeSettings?.borderColor || brandColor || "#127E10"}`,
            } : {}),
            zIndex: 20,
          }}
        >
          <div
            style={{
              // Only apply inner frame styling if showFrame is true
              ...(qrCodeSettings?.showFrame !== false ? {
                backgroundColor: qrCodeSettings?.backgroundTransparent 
                ? 'transparent' 
                : (qrCodeSettings?.backgroundColor || brandColor || "#ffffff"),
                borderRadius: "2vw",
                textAlign: "center",
              } : {
                textAlign: "center",
              }),
            }}
          >
            {/* Only show header text if showFrame is true */}
            {qrCodeSettings?.showFrame !== false && (
              <div
                style={{
                  fontSize: pxToVw(qrCodeSettings?.headerFontSize || 30),
                  fontWeight: "bold",
                  color: qrCodeSettings?.headerColor || brandColor || "#127E10",
                  marginBottom: "2vw",
                }}
              >
                {getTextForLanguage(qrCodeSettings?.headerText, "Scan Me")}
              </div>
            )}
            <img
              src={qrCodeUrlWithLanguage}
              alt="QR Code"
              style={{
                // Use pxToVw for responsive sizing based on global settings
                width: "80%",
                height: "80%",
                display: "block",
                margin: "0 auto",
                objectFit: "contain",
              }}
              data-language={currentLanguage}
              data-qr-type={qrCodeConfig?.enableDirectMapLinkQr && locationData?.directMapLinkQrCode?.[currentLanguage]?.fileUrl ? 'direct-map-link' : 'regular'}
            />
            {/* Only show footer text if showFrame is true */}
            {qrCodeSettings?.showFrame !== false && (
              <div
                style={{
                  fontSize: pxToVw(qrCodeSettings?.footerFontSize || 30),
                  color: qrCodeSettings?.footerColor || "#666",
                  marginTop: "2vw",
                  lineHeight: 1.2,
                }}
              >
                {getTextForLanguage(qrCodeSettings?.footerText, "Get directions on your phone")}
              </div>
            )}
          </div>
        </motion.div>
      )}

      {/* Weather Widget */}
      {weatherSettings?.enabled && weatherSettings?.visibility?.avatarScreen && (
        <div
          style={{
            position: 'fixed',
            top: weatherSettings.positionTop !== null && weatherSettings.positionTop !== undefined ? `${weatherSettings.positionTop}%` : 'auto',
            bottom: weatherSettings.positionBottom !== null && weatherSettings.positionBottom !== undefined ? `${weatherSettings.positionBottom}%` : 'auto',
            ...(weatherSettings.horizontalAlign === 'center'
              ? { left: '50%', right: 'auto', transform: 'translateX(-50%)' }
              : {
                left: weatherSettings.positionLeft !== null && weatherSettings.positionLeft !== undefined ? `${weatherSettings.positionLeft}%` : 'auto',
                right: weatherSettings.positionRight !== null && weatherSettings.positionRight !== undefined ? `${weatherSettings.positionRight}%` : 'auto',
              }
            ),
            zIndex: 20,
          }}
        >
          <WeatherWidget
            apiKey={weatherSettings.weatherApiKey}
            latitude={weatherSettings.latitude}
            longitude={weatherSettings.longitude}
            forecastDays={weatherSettings.forecastDays || 3}
            temperatureUnit={weatherSettings.temperatureUnit || 'both'}
            celsiusFirst={weatherSettings.celsiusFirst !== false}
            showLocation={weatherSettings.showLocation || false}
            showClock={weatherSettings.showClock !== false}
            showCurrentWeather={weatherSettings.showCurrentWeather !== false}
            showForecast={weatherSettings.showForecast !== false}
            widgetOrder={weatherSettings.widgetOrder || ['clock', 'current', 'forecast']}
            backgroundColor={weatherSettings.backgroundColor || '#ffffff'}
            backgroundOpacity={weatherSettings.backgroundOpacity ?? 80}
            textColor={weatherSettings.textColor || '#1a202c'}
            subTextColor={weatherSettings.subTextColor || '#718096'}
            padding={weatherSettings.padding ?? 16}
            borderRadius={weatherSettings.borderRadius ?? 12}
            width={weatherSettings.width || 0}
            fontFamily={weatherSettings.fontFamily === 'inherit' || !weatherSettings.fontFamily ? brandFont || 'inherit' : weatherSettings.fontFamily}
            fontSize={weatherSettings.fontSize || 14}
            iconSize={weatherSettings.iconSize || 40}
            forecastIconSize={weatherSettings.forecastIconSize || 28}
            shadowH={weatherSettings.shadowH ?? 0}
            shadowV={weatherSettings.shadowV ?? 4}
            shadowBlur={weatherSettings.shadowBlur ?? 12}
            shadowSpread={weatherSettings.shadowSpread ?? 0}
            shadowColor={weatherSettings.shadowColor || '#000000'}
            shadowOpacity={weatherSettings.shadowOpacity ?? 15}
            useVwSizing={true}
          />
        </div>
      )}

      {/* <WayfinderDialog
        open={timeoutOpen}
        onClose={handleContinue}
        settings={timeoutPopupSettings || dialogSettings}
        brandColor={brandColor}
        brandFont={brandFont}
        countdown={timeoutCountdown}
        showCountdown={true}
        onClick={handleContinue}
      /> */}

      {/* New Custom Replay Popup with Three Buttons */}
      {renderReplayPopup()}

      <LoadingOverlay isLoading={isLoading} />
    </div>
  );
};

export default AvatarScreen;
